/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import UnNumberedList from "reusables/TextFormats/UnNumberedList";

// Images

function FAQ_Section1() {
  const lineSpacing_lg = <MKBox mb={12} />;
  const lineSpacing_sm = <MKBox mb={2} />;
  const secondSubTitle = (text) => (
    <MKTypography
      component="div"
      color="text"
      variant="h4"
      mt={0}
      mb={1}
      fontWeight="bold"
      sx={{ textAlign: "justify" }}
    >
      {text}
    </MKTypography>
  );

  return (
    <Container>
      <Grid
        container
        alignItems="center"
        // bgcolor={"red"}
        width={"100%"}
      >
        <Grid item xs={12}>
          <SubTitleContents
            title="Cleaning Services Frequently Asked Questions"
            contents={
              <>
                {secondSubTitle("Why should I choose Spechs over your competitors?")}
                We prioritise both residential and commercial cleaning with a commitment to
                excellence and professionalism. Our rigorous hiring process and focus on employee
                satisfaction result in a high staff retention rate, ensuring consistent quality.
                Additionally, we tailor every cleaning experience to meet your specific needs,
                whether for your home or business.
                {lineSpacing_sm}
                {secondSubTitle("How often can you clean my property?")}
                We offer flexible cleaning schedules, including daily, weekly, fortnightly, or
                monthly options. Whether you require ongoing maintenance for a commercial space or
                periodic cleaning for your home, we customise our services to your requirements.
                {lineSpacing_sm}
                {secondSubTitle("What cleaning products do you use?")}
                We supply all cleaning products and equipment to ensure a thorough and
                environmentally considerate service. Our range includes:
                {/* <MKBox mb={2} /> */}
                <UnNumberedList
                  items={[
                    "All-purpose Cleaner: Ideal for various surfaces without damage.",
                    "Glass Cleaner: Ensures streak-free windows and mirrors.",
                    "Peroxide Cleaner: Safely cleans grout and tiles.",
                    "Degreaser: Cuts through tough kitchen grease without harsh chemicals.",
                    "Floor Cleaner: Suitable for most hard floors, leaving them gleaming.",
                    "For deep cleaning, we occasionally use less eco-friendly products, but our primary focus is on safety and sustainability.",
                  ]}
                />
                {lineSpacing_sm}
                {secondSubTitle("Can I get a quote without a site visit?")}
                Yes! We offer free, no-obligation online estimates. For complex projects, an
                in-person assessment may be required for precision. Simply contact us via email or
                WhatsApp to request a quote.
                {lineSpacing_sm}
                {secondSubTitle("Do you service areas outside Dublin?")}
                Absolutely. We provide cleaning services across most of Ireland. Contact us to
                confirm availability in your area.
                {lineSpacing_sm}
                {secondSubTitle("Do I need to be present during the cleaning?")}
                No. You can provide access via a key box, code, or other secure methods. If you’d
                prefer to be on-site, we’d be delighted to meet you in person.
                {lineSpacing_sm}
                {secondSubTitle("How do you handle pets during cleaning?")}
                We’re pet-friendly! Let us know about your pets in advance so we can ensure their
                safety and ours while we work.
                {lineSpacing_sm}
                {secondSubTitle("How will the cleaning team access my property?")}
                You can provide a spare key, access code, or leave instructions for a secure
                location. Rest assured, all keys and access details are handled with the utmost
                security. If we cannot access your property, a lockout fee may apply as per our
                Terms & Conditions.
                {lineSpacing_sm}
                {secondSubTitle("Is your company insured?")}
                Yes. Our staff are fully insured against loss or damage during cleaning, and we also
                cover employment taxes and workers&#39; compensation.
                {lineSpacing_sm}
                {secondSubTitle("How do I reschedule or cancel a cleaning?")}
                Please provide at least 24 hours&#39; notice to avoid cancellation fees.
                Rescheduling within the same week incurs no extra charge. Exceptions can be made for
                emergencies.
                {lineSpacing_sm}
                {secondSubTitle("Do I need to prepare for the cleaning?")}
                No cleaning is needed before our visit! Simply ensure access to the property, disarm
                alarms, and tidy up clutter to maximise efficiency.
                {lineSpacing_sm}
                {secondSubTitle("What if I’m not satisfied with the service?")}
                We guarantee satisfaction. If you’re unhappy with any aspect of our cleaning,
                contact us within 24 hours, and we’ll address it promptly. Positive feedback? Share
                it in a review – we love hearing from happy clients!
              </>
            }
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default FAQ_Section1;
